module.exports = __webpack_public_path__ + "32d16200ebfaacb3a98e3a49acaaf64d.webmanifest";